import { t } from "../i18n";

const gamesData = {
    "Counter Strike 2": {
      id: 1,
      genre: t("counter_strike_2_genre"),
      about: t("counter_strike_2_about"),
      carouselImage: require("../assets/GameImages/CCS2.jfif"),
      groupId: 82,
    },
    "Marvel Rivals": {
      id: 2,
      genre: t("marvel_rivals_genre"),
      about: t("marvel_rivals_about"),
      carouselImage: require("../assets/GameImages/CMR.jfif"),
      groupId: 83,
    },
    "Dota 2": {
      id: 3,
      genre: t("dota_2_genre"),
      about: t("dota_2_about"),
      carouselImage: require("../assets/GameImages/CD2.jfif"),
      groupId: 84,
    },
    "Monster Hunter Wilds": {
      id: 4,
      genre: t("monster_hunter_wilds_genre"),
      about: t("monster_hunter_wilds_about"),
      carouselImage: require("../assets/GameImages/CMHW.jfif"),
      groupId: 85,
    },
    "Stardew Valley": {
      id: 5,
      genre: t("stardew_valley_genre"),
      about: t("stardew_valley_about"),
      carouselImage: require("../assets/GameImages/Stardew-Valley.jfif"),
      groupId: 86,
    },
    "R.E.P.O": {
      id: 6,
      genre: t("repo_genre"),
      about: t("repo_about"),
      carouselImage: require("../assets/GameImages/CR.jfif"),
      groupId: 87,
    },
    "Destiny 2": {
      id: 7,
      genre: t("destiny_2_genre"),
      about: t("destiny_2_about"),
      carouselImage: require("../assets/GameImages/CDestiny2.jfif"),
      groupId: 88,
    },
    "EA SPORTS FC™ 25": {
      id: 8,
      genre: t("ea_sports_fc_25_genre"),
      about: t("ea_sports_fc_25_about"),
      carouselImage: require("../assets/GameImages/CEAFC25.jfif"),
      groupId: 89,
    },
    "Cyberpunk 2077": {
      id: 9,
      genre: t("cyberpunk_2077_genre"),
      about: t("cyberpunk_2077_about"),
      carouselImage: require("../assets/GameImages/CC2077.jfif"),
      groupId: 90,
    },
    "Rust": {
      id: 10,
      genre: t("rust_genre"),
      about: t("rust_about"),
      carouselImage: require("../assets/GameImages/CRust.jfif"),
      groupId: 91,
    },
    "PUBG: BATTLEGROUNDS": {
      id: 11,
      genre: t("pubg_battlegrounds_genre"),
      about: t("pubg_battlegrounds_about"),
      carouselImage: require("../assets/GameImages/pubg.jfif"),
      groupId: 92,
    },
    "Apex Legends": {
      id: 12,
      genre: t("apex_legends_genre"),
      about: t("apex_legends_about"),
      carouselImage: require("../assets/GameImages/apexL.jfif"),
      groupId: 93,
    },
    "Tom Clancy's Rainbow Six Siege": {
      id: 13,
      genre: t("rainbow_six_siege_genre"),
      about: t("rainbow_six_siege_about"),
      carouselImage: require("../assets/GameImages/r6.jfif"),
      groupId: 94,
    },
    "Warframe": {
      id: 14,
      genre: t("warframe_genre"),
      about: t("warframe_about"),
      carouselImage: require("../assets/GameImages/warframe.jfif"),
      groupId: 95,
    },
    "Team Fortress 2": {
      id: 15,
      genre: t("team_fortress_2_genre"),
      about: t("team_fortress_2_about"),
      carouselImage: require("../assets/GameImages/tf2.jfif"),
      groupId: 96,
    },
    "Palworld": {
      id: 16,
      genre: t("palworld_genre"),
      about: t("palworld_about"),
      carouselImage: require("../assets/GameImages/palworld.jfif"),
      groupId: 97,
    },
    "ELDEN RING": {
      id: 17,
      genre: t("elden_ring_genre"),
      about: t("elden_ring_about"),
      carouselImage: require("../assets/GameImages/eldenring.jfif"),
      groupId: 98,
    },
    "The Sims™ 4": {
      id: 18,
      genre: t("the_sims_4_genre"),
      about: t("the_sims_4_about"),
      carouselImage: require("../assets/GameImages/sims4.jfif"),
      groupId: 99,
    },
    "Overwatch® 2": {
      id: 19,
      genre: t("overwatch_2_genre"),
      about: t("overwatch_2_about"),
      carouselImage: require("../assets/GameImages/overwatch2.jfif"),
      groupId: 100,
    },
    "Sid Meier's Civilization VI": {
      id: 20,
      genre: t("civilization_vi_genre"),
      about: t("civilization_vi_about"),
      carouselImage: require("../assets/GameImages/civ6.jfif"),
      groupId: 101,
    },
};

export default gamesData;